import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { isNullOrUndefined } from 'util';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

@Injectable()
export class ExcelService {
  selectedcomp: any;

  constructor(
    private router : Router,
    private datePipe: DatePipe
  ) { }

  public downloadFile(downloadOptions: object, headers: any[], data: any[], headerCons: object[], metaData: object) {
    // this.selectedcomp = this.router.url.split("/")[2].split("-")[0];
    let downloadType: string = downloadOptions['downloadType'];
    // let downloadFileName: string = this.selectedcomp + '_actual';
    let downloadFileName: string = downloadOptions['downloadFileName'];
    let meta: boolean = downloadOptions['metaData'];
    if (downloadType == 'xls' || downloadType == 'xlsx') {
      this.exportAsExcelFile(data, headers, downloadFileName, meta, metaData, headerCons);
    }
    else if (downloadType == 'csv') {
      this.exportTableToCSV(data, headers, downloadFileName);
    }
    else {
      this.downloadAsJson(headerCons, data, downloadFileName)
    }

  }

  private exportAsExcelFile(data: any[], headers: any[], excelFileName: string, meta: boolean, metaData: object, headerCons: object[]) {
    let excelBuffer = this.setExcelData(headers, data, excelFileName, meta, metaData, headerCons);
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(excelData: any, fileName: string): void {
    let blob = new Blob([excelData], { type: "application/vnd.ms-excel;charset=utf-8" });
    FileSaver.saveAs(blob, fileName + '.xls');
  }

  private setExcelData(headers, recordData, xlsfilename, meta, metaData, headerCons) {
    xlsfilename += '.xls;'
    let tableHTML = this.createNewTable(headers, recordData, meta, metaData, headerCons);
    let excelFile = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>";
    excelFile += "<head>";
    excelFile += "<!--[if gte mso 9]>";
    excelFile += "<xml>";
    excelFile += "<x:ExcelWorkbook>";
    excelFile += "<x:ExcelWorksheets>";
    excelFile += "<x:ExcelWorksheet>";
    excelFile += "<x:Name>";
    excelFile += xlsfilename;
    excelFile += "</x:Name>";
    excelFile += "<x:WorksheetOptions>";
    excelFile += "<x:DisplayGridlines/>";
    excelFile += "</x:WorksheetOptions>";
    excelFile += "</x:ExcelWorksheet>";
    excelFile += "</x:ExcelWorksheets>";
    excelFile += "</x:ExcelWorkbook>";
    excelFile += "</xml>";
    excelFile += "<![endif]-->";
    excelFile += "</head>";
    excelFile += "<body>";
    excelFile += tableHTML;
    excelFile += "</body>";
    excelFile += "</html>";

    return excelFile;
  }

  // private createNewTable(headers, recordData, meta, metaData) {
  //   let numberOfRows = recordData.length;
  //   let totalColumns = recordData[0].length;
  //   let tableForDownload = "";
  //   if (meta) {
  //     tableForDownload += this.addMetaData(metaData);
  //   }
  //   tableForDownload += "<table><thead>";

  //   headers.forEach((header) => {
  //     tableForDownload += "<tr>";
  //     header.forEach(record => {
  //       tableForDownload += '\t\t\t\t<th colspan="' + record.cols + '" rowspan="' + record.rows + '">' + record.name + '</th>';
  //     });
  //     tableForDownload += '</tr>';
  //   })
  //   tableForDownload += '</thead>\n<tbody>\n';

  //   if (recordData.length > 0) {
  //     for (let row = 0; row < numberOfRows; row++) {
  //       tableForDownload += '\t\t\t<tr>\n';
  //       for (let column = 0; column < totalColumns; column++) {
  //         let recordValue = recordData[row][column];
  //         if (recordValue) {
  //           let cellValue = recordData[row][column].values;
  //           if (recordData[row][column].values.length > 1) {
  //             cellValue = cellValue[0];
  //           }
  //           tableForDownload += '\t\t\t\t<td>' + ((cellValue != null && cellValue != undefined) ? cellValue : '-') + '</td>' + '\n';
  //         }
  //         else {
  //           tableForDownload += '<td>-</td>';
  //         }
  //       }
  //       tableForDownload += '\t\t\t</tr>\n';
  //     }
  //   } else {
  //     tableForDownload += '\t\t\t<tr>\n<td>No data to display!</td></tr>';
  //   }
  //   return tableForDownload += '</tbody><table>';
  // }

  private createNewTable(headers, recordData, meta, metaData, headerCons) {
    let numberOfRows = recordData.length;
    let totalColumns = recordData[0].length;
    let tableForDownload = "";
    let leafColumns = this.flattenLeafColumns(headerCons);
    if (meta) {
      tableForDownload += this.addMetaData(metaData);
    }

    tableForDownload += "<table border='1'><thead>";

    // headers
    headers.forEach((header) => {
      tableForDownload += "<tr>";
      header.forEach(record => {
        tableForDownload += `<th colspan="${record.cols}" rowspan="${record.rows}">${record.name}</th>`;
      });
      tableForDownload += "</tr>";
    });

    tableForDownload += "</thead>\n<tbody>\n";

    // rows
    if (recordData.length > 0) {
      for (let row = 0; row < numberOfRows; row++) {
        tableForDownload += "<tr>\n";

        for (let column = 0; column < totalColumns; column++) {
          let recordValue = recordData[row][column];
          let cellValue: string = "-";

          // normalize value
          if (recordValue && recordValue.values != null) {
            if (Array.isArray(recordValue.values)) {
              //   cellValue = recordValue.values.filter(v => v != null).join(", "); // join arrays
              // } else {
              //   cellValue = recordValue.values.toString();
              cellValue = recordValue.values[0];
              if (recordValue.dataType && (recordValue.dataType[0] === 'DATE' || recordValue.dataType[0] === 'DATETIME')) {
                cellValue = this.formatDate(cellValue, recordValue.format);
              }
            }
          }

          // 🔹 Style only Category column
          let style = "color:black;";
          let bgcolor = "";

          let columnDef = leafColumns[column];
          if (!isNullOrUndefined(columnDef) && typeof columnDef.excelStyle === 'function') {
            // Column supplies its own UI color resolver, so the export matches the on-screen table.
            // <font color> and align are emitted alongside CSS since LibreOffice ignores CSS color/text-align on <td>.
            const cellStyle = columnDef.excelStyle(isNullOrUndefined(cellValue) ? '-' : cellValue) || {};
            const textColor = cellStyle.textcolor || '#000000';
            const align = cellStyle.textAlign ? ` align="${cellStyle.textAlign}"` : "";
            const bg = cellStyle.bgcolor ? ` bgcolor="${cellStyle.bgcolor}"` : "";
            tableForDownload += `<td${bg}${align} style="color:${textColor};"><font color="${textColor}">${cellValue}</font></td>\n`;
            continue;
          } else if (!isNullOrUndefined(columnDef) && columnDef.name === "Category") {
            const category = (typeof cellValue === 'string' ? cellValue : String(cellValue)).toLowerCase();

            if (category.includes("very heavy rain")) {
              bgcolor = "#FC0300"; style = "color:white;";
            } else if (category.includes("heavy rain")) {
              bgcolor = "#FDBFC9"; style = "color:black;";
            } else if (category.includes("moderate rain")) {
              bgcolor = "#038500"; style = "color:black;";
            } else if (category.includes("very light rain")) {
              bgcolor = "#C3FDCA"; style = "color:black;";
            } else if (category.includes("light rain")) {
              bgcolor = "#00FE08"; style = "color:black;";
            } else if (category.includes("extremely heavy rain")) {
              bgcolor = "#610301"; style = "color:white;";
            } else if (category.includes("no rain") || category === "-") {
              bgcolor = "#ffffff"; style = "color:black;";
            }
          }

          tableForDownload += `<td ${bgcolor ? `bgcolor="${bgcolor}"` : ""} style="${style}">${cellValue}</td>\n`;
        }

        tableForDownload += "</tr>\n";
      }
    } else {
      tableForDownload += "<tr><td>No data to display!</td></tr>";
    }

    return tableForDownload += "</tbody></table>";
  }

  private exportTableToCSV(recordData, headers, filename) {
    let csvs = [];
    let rowArray = [];
    let startIndex = 0;
    let headerArray = [];

    for (let i = 0; i < headers[0].length; i++) {
      let headerValue = headers[0][i];
      if (headerValue.cols == 1) {
        headerArray.push(headerValue.name);
      }
      else {
        getHeaderName(headers, 1, startIndex, startIndex + headerValue.cols, headerValue.name);
        startIndex += headerValue.cols;
      }
    }

    function getHeaderName(header: object, headerIndex: number, index: number, columns: number, baseName: string) {
      for (let i = index; i < columns; i++) {
        if (header[headerIndex][i].cols == 1) {
          headerArray.push(baseName + '.' + header[headerIndex][i].name);
        }
        else {
          getHeaderName(headers, headerIndex + 1, index, index + header[headerIndex][i].cols, baseName + '.' + header[headerIndex][i].name);
          startIndex += header[headerIndex][i].cols;
        }
      }
    }

    let header = headerArray.join(',');
    rowArray.push(header);

    for (let i = 0; i < recordData.length; i++) {
      let rows = [], cols = recordData[i].length;
      for (let j = 0; j < cols; j++) {
        let recordValue = recordData[i][j];
        if (recordValue) {
          let cellValue = recordValue.dataType.length == 1 ? recordData[i][j].values : recordData[i][j].values.join(':');
          if (Array.isArray(cellValue)) {
            cellValue = cellValue[0];
          }
          if (recordValue.dataType && (recordValue.dataType[0] === 'DATE' || recordValue.dataType[0] === 'DATETIME')) {
            cellValue = this.formatDate(cellValue, recordValue.format);
          }
          let pushValue = (cellValue != null && cellValue != undefined) ? cellValue : '-';
          rows.push(pushValue);
        }
        else {
          rows.push('-');
        }
      }
      let row = rows.join(",");
      rowArray.push(row);
    }
    csvs.push(rowArray.join("\n"));
    this.downloadCSV(csvs, filename);
  }

  private downloadCSV(csv, filename) {
    let csvFile = new Blob([csv], { type: "text/csv" });
    FileSaver.saveAs(csvFile, filename + '_' + new Date().getTime() + '.csv');

  }

  private downloadAsJson(headers, data, filename) {
    let finalObject = []
    if (data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        let o = this.setDataObject(headers, data[i], 0);
        finalObject.push(o);
      }
    }
    let jsonString = JSON.stringify(finalObject);
    let jsonFile = new Blob([jsonString], { type: "text" });
    FileSaver.saveAs(jsonFile, filename + '_' + new Date().getTime() + '.json');
  }

  private setDataObject(headers, record, index) {
    let jsonObject: Object = {};
    let ind = index;
    headers.forEach((header) => {
      if (!isNullOrUndefined(header.childs) && header.childs.length > 0) {
        jsonObject[header.name] = this.setDataObject(header.childs, record, ind);
      }
      else {
        jsonObject[header.name] = record[ind].values;
        ind++;
      }
    });
    return jsonObject;
  }

  // Flattens the (possibly nested, via `childs`) column config into the same
  // depth-first, leaf-only order used for recordData columns, dataTypes and jsonKeys
  // in DataTableService.getHeaders(), so cell values can be matched to their column
  // definition by index. `headers[0]` cannot be used for this since it only holds
  // one entry per top-level header (grouped columns collapse their children into one).
  private flattenLeafColumns(columns: any[]): any[] {
    let leafColumns = [];
    if (isNullOrUndefined(columns)) {
      return leafColumns;
    }
    columns.forEach(column => {
      if (!isNullOrUndefined(column.childs) && column.childs.length > 0) {
        leafColumns = leafColumns.concat(this.flattenLeafColumns(column.childs));
      } else {
        leafColumns.push(column);
      }
    });
    return leafColumns;
  }

  private addMetaData(metaData) {
    let metaEntries = Object.entries(metaData);
    var mData = '<table>';

    metaEntries.forEach(entry => {
      mData += "<tr><th>" + entry[0] + "</th><th>" + entry[1] + "</th></tr>";
    })
    mData += "<tr><th></th><th></th></tr>";
    mData += "</table>";
    return mData;
  }

  private formatDate(value: any, format: string): string {
    if (isNullOrUndefined(value) || value === '-') {
      return '-';
    }
    const defaultFormat = 'MMM d, y';
    return this.datePipe.transform(value, format || defaultFormat) || '-';
  }
}
